export default __webpack_public_path__ + "static/media/coronary-flow-logo-dark.1b6dffdd.png";